// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-layer[data-v-7214ccc7]{width:100%;height:100%;position:absolute;top:0;left:0}.loading-layer-background[data-v-7214ccc7]{background-color:rgba(255,255,255,.5)}", ""]);
// Exports
module.exports = exports;
